var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { attrs: { name: "query-sort-block" } },
        [
          _c("swb-query-sort-area", {
            ref: "query_model_ctrl",
            attrs: {
              confKey: _vm.confKey,
              configAuto: true,
              queryOnLoad: true,
              queryHandler: _vm.queryHandler
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "tab-container small base",
          attrs: { name: "tab-container" }
        },
        [
          _c("div", { staticClass: "tabs-nav" }, [
            _c(
              "ul",
              { staticClass: "head" },
              _vm._l(_vm.tabList, function(item) {
                return _c(
                  "li",
                  {
                    staticClass: "head-item",
                    class: { current: item.value == _vm.checkValue },
                    on: {
                      click: function($event) {
                        _vm.tabChange(item.value)
                      }
                    }
                  },
                  [_c("span", [_vm._v(_vm._s(item.text))])]
                )
              })
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("swb-result-table", {
        ref: "result_table",
        attrs: {
          name: "result_table",
          confKey: _vm.confKey,
          configAuto: true,
          needPager: _vm.needPager,
          multiSelect: _vm.multiSelect,
          multiPageSelect: _vm.multiPageSelect,
          rowKeyPropName: _vm.rowKeyPropName,
          rowNoShow: _vm.rowNoShow,
          rowNoFixed: _vm.rowNoFixed,
          height: _vm.theTableHeight,
          pageNoChangeHandler: _vm.pageNoChangeHandler
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dbf6c0f4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dbf6c0f4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/categ/BrandListForSelect.vue
// module id = 2319
// module chunks = 0